// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"ad0fadee","178":"a09ab7bb","787":"b59edec7","818":"4d500c2e"}[chunkId] + ".chunk.js";
};